import StoreModule from "@/utils/StoreModule";

const customsTransactions = StoreModule("/customs/customs-transactions");

export default customsTransactions;
